export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Premium Bank',
    headline: 'Unlimited Trasnactions with zero fees',
    description: 'Get access to our exclusive app that allows you to send unlimited transactions without getting charged any fees.',
    buttonLabel: 'Get started',
    imgStart: false,
    img: require('../../images/svg-3.svg').default,
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false
}

export const homeObjTwo = {
    id: 'discover',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Unlimited Access',
    headline: 'Login to your account at any time',
    description: 'Manage your account with just one click. Our bank application makes it more easy for you to maintain your account anywhere anytime.',
    buttonLabel: 'Learn more',
    imgStart: true,
    img: require('../../images/svg-1.svg').default,
    alt: 'Maintain',
    dark: false,
    primary: false,
    darkText: true
}

export const homeObjThree = {
    id: 'signup',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Join our Team',
    headline: 'Creating an account is extremely easy',
    description: 'Get everything set up in just under 10 minutes. All you need is to add your information and you are ready to go!',
    buttonLabel: 'Start Now',
    imgStart: false,
    img: require('../../images/svg-2.svg').default,
    alt: 'Online payment',
    dark: false,
    primary: false,
    darkText: true
}